import Image from "next/image";

import styles from "./slide.module.scss";

const Slide = ({ image, title, byline, onClick }) => {
  return (
    <div className={styles.Slide} onClick={onClick}>
      <div className={styles.ImageWrapper}>
        <Image
          src={image}
          alt={title}
          width="353"
          height="353"
          layout="responsive"
        />
      </div>
      <div className={styles.SlideContent}>
        <h3>{title}</h3>
        <p>{byline}</p>
      </div>
    </div>
  );
};

export default Slide;
